<unity-action-shared [gridIconOnly]="$gridIconOnly()" [action]="$action()" [disabled]="$disabled()" (clickEvent)="onClick()" />
